<template>
  <div>
    <v-card elevation="2">
      <v-toolbar color="primary" class="white--text" dense>
        <v-icon left color="white">mdi-car</v-icon>
        Road Skills Test Results
      </v-toolbar>
      <v-card-subtitle>
        <p>
          According to our records, you have taken the following road skills
          test(s). To view additional details, select "View Details" next to the
          desired road skills test.
        </p>
      </v-card-subtitle>
      <v-card-text>
        <div class="testResults">
          <v-simple-table dense>
            <thead>
              <tr>
                <th class="text-left">Road Test Date</th>
                <th class="text-left">DMV ID Number</th>
                <th class="text-left">Test Site Location</th>
                <th class="text-left">License Class</th>
                <th class="text-left">View</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(test, index) in testResults" :key="index">
                <td>
                  <div class="d-none display-sm-table font-weight-medium">
                    Test Date:
                  </div>
                  {{ new Date(test.TestDate).toLocaleDateString() }}
                </td>
                <td>
                  <div class="d-none display-sm-table font-weight-medium">
                    DMV ID Number:
                  </div>
                  {{ test.CID }}
                </td>
                <td>
                  <div class="d-none display-sm-table font-weight-medium">
                    Test Site Location:
                  </div>
                  {{ test.TestSiteName }}
                </td>
                <td>
                  <div class="d-none display-sm-table font-weight-medium">
                    License Class:
                  </div>
                  {{ test.LicenseClass }}
                </td>
                <td>
                  <span>
                    <a href="#" @click="viewDetails(index)">View Details</a>
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
      <v-card-subtitle v-if="showTempLicenseHelp"
        ><p>
          Please select “View Details” to access your Class D/DJ/M/MJ Temporary
          License.
        </p></v-card-subtitle
      >
    </v-card>

    <TestResultDetails
      v-if="showDetails"
      :results="testResults[selectedIndex]"
      @showReceipt="showReceipt"
    />

    <div>
      <v-card class="mt-2" elevation="2">
        <v-toolbar color="primary" class="white--text" dense>
          <v-icon left color="white">mdi-information-outline</v-icon>
          Further Information
        </v-toolbar>
        <v-card-text>
          <ul>
            <li>
              <ExternalLink
                text="Schedule and take another road test"
                url="https://dmv.ny.gov/schedule-road-test"
              />
            </li>
            <li>
              <ExternalLink
                text="New York State Driver’s Manual and practice test"
                url="https://dmv.ny.gov/driver-license/drivers-manual-practice-tests"
              />
            </li>
            <li>
              <ExternalLink
                text="See information about DMV offices and reservations."
                url="https://dmv.ny.gov/offices/county-offices"
              />
            </li>
            <li>
              <ExternalLink text="Get a CDL" url="https://dmv.ny.gov/get-cdl" />
            </li>
            <li>
              <ExternalLink
                text="Driver License Endorsement and Restriction Codes"
                url="https://dmv.ny.gov/driver-license/driver-license-endorsement-and-restriction-codes"
              />
            </li>
          </ul>
          <br />
        </v-card-text>
      </v-card>
    </div>
    <!-- <pre>Test Data: {{ testResults }}</pre> -->
  </div>
</template>

<script>
import TestResultDetails from '@/components/TestResultDetails';
import ExternalLink from '@/components/ExternalLink';

export default {
  name: 'TestResults',
  components: {
    TestResultDetails,
    ExternalLink,
  },
  props: {
    testData: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    showDetails: false,
    selectedIndex: 0,
  }),
  computed: {
    testResults() {
      return this.testData;
    },
    showTempLicenseHelp() {
      let result = false;
      if (
        this.testData.some((e) => e.IsCDLTest === false) &&
        this.testData.some((e) => e.OverallResult === 'Pass')
      ) {
        result = true;
      }
      return result;
    },
  },
  methods: {
    showReceipt() {
      this.$emit('navigateTo', 'Receipt', this.testData, this.selectedIndex);
    },
    viewDetails(index) {
      this.showDetails = true;
      this.selectedIndex = index;
    },
    resultColor(result) {
      let color;
      switch (result) {
        case 'Pass':
          color = 'green--text text--darken-2';
          break;
        case 'Fail':
          color = 'red--text text--darken-2';
          break;
        default:
          color = 'blue--text text--darken-2';
      }

      return color;
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .display-sm-table {
    display: inline-block !important;
  }

  /* Force table to not be like tables anymore */
  .testResults table,
  .testResults thead,
  .testResults tbody,
  .testResults th,
  .testResults td,
  .testResults tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .testResults thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .testResults tr {
    border: 1px solid #ccc;
  }

  .testResults td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }

  .testResults td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }
}

p {
  color: black;
}
</style>
